import { render, staticRenderFns } from "./complianceItem.vue?vue&type=template&id=6095c7e4"
import script from "./complianceItem.vue?vue&type=script&lang=js"
export * from "./complianceItem.vue?vue&type=script&lang=js"
import style0 from "./complianceItem.vue?vue&type=style&index=0&id=6095c7e4&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6095c7e4')) {
      api.createRecord('6095c7e4', component.options)
    } else {
      api.reload('6095c7e4', component.options)
    }
    module.hot.accept("./complianceItem.vue?vue&type=template&id=6095c7e4", function () {
      api.rerender('6095c7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/complianceItem.vue"
export default component.exports